import {
  __decorateClass
} from "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icon.element.ts
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { Task } from "@lit/task";

// libs/ui-components/src/lib/modules/icon/icons/index.ts
var icons = {
  circle16: { width: "16px", height: "16px", loader: () => import("./circle_16.svg-ZXVELFJT.js").then((m) => m.circle16Svg) },
  cross8: { width: "8px", height: "8px", loader: () => import("./cross_8.svg-UQSEH4S4.js").then((m) => m.cross8Svg) },
  startDefault16: { width: "16px", height: "16px", loader: () => import("./start-default_16.svg-CD2J7L7X.js").then((m) => m.startDefault16Svg) },
  connect16: { width: "16px", height: "16px", loader: () => import("./connect_16.svg-NSXNVWXM.js").then((m) => m.connect16Svg) },
  cornerDownRight16: { width: "16px", height: "16px", loader: () => import("./corner-down-right_16.svg-YYSNWS3X.js").then((m) => m.cornerDownRight16Svg) },
  chevronDown16: { width: "16px", height: "16px", loader: () => import("./chevron-down_16.svg-BND54YF5.js").then((m) => m.chevronDown16Svg) },
  arrowDown16: { width: "16px", height: "16px", loader: () => import("./arrow-down_16.svg-IK237GS3.js").then((m) => m.arrowDown16Svg) },
  fusion16: { width: "16px", height: "16px", loader: () => import("./fusion_16.svg-DS2KKM4D.js").then((m) => m.fusion16Svg) },
  link16: { width: "16px", height: "16px", loader: () => import("./link_16.svg-ILSOSF3Q.js").then((m) => m.link16Svg) },
  plusCircle16: { width: "16px", height: "16px", loader: () => import("./plus-circle_16.svg-LAFJERR4.js").then((m) => m.plusCircle16Svg) },
  trash16: { width: "16px", height: "16px", loader: () => import("./trash_16.svg-TZDW5QXS.js").then((m) => m.trash16Svg) },
  xCircle16: { width: "16px", height: "16px", loader: () => import("./x-circle_16.svg-PAYSKKZ6.js").then((m) => m.xCircle16Svg) },
  circle24: { width: "24px", height: "24px", loader: () => import("./circle_24.svg-NZRHXSXM.js").then((m) => m.circle24Svg) },
  arrowDown24: { width: "24px", height: "24px", loader: () => import("./arrow-down_24.svg-QVWWMIAG.js").then((m) => m.arrowDown24Svg) },
  arrowLeft24: { width: "24px", height: "24px", loader: () => import("./arrow-left_24.svg-SRUSUV6K.js").then((m) => m.arrowLeft24Svg) },
  cross24: { width: "24px", height: "24px", loader: () => import("./cross_24.svg-Y6TXDXMZ.js").then((m) => m.cross24Svg) },
  search24: { width: "24px", height: "24px", loader: () => import("./search_24.svg-7BVVC7QD.js").then((m) => m.search24Svg) },
  edit24: { width: "24px", height: "24px", loader: () => import("./edit_24.svg-LIXQVG7G.js").then((m) => m.edit24Svg) },
  trash24: { width: "24px", height: "24px", loader: () => import("./trash_24.svg-E6QQAHPV.js").then((m) => m.trash24Svg) },
  connect24: { width: "24px", height: "24px", loader: () => import("./connect_24.svg-B72L67KC.js").then((m) => m.connect24Svg) },
  link24: { width: "24px", height: "24px", loader: () => import("./link_24.svg-ME7P2JZJ.js").then((m) => m.link24Svg) },
  bell24: { width: "24px", height: "24px", loader: () => import("./bell_24.svg-TDYDRRA3.js").then((m) => m.bell24Svg) },
  alert24: { width: "24px", height: "24px", loader: () => import("./alert_24.svg-ASSJ27DL.js").then((m) => m.alert24Svg) },
  l2Chain24: { width: "24px", height: "24px", loader: () => import("./l2-chain_24.svg-BVBNWDAX.js").then((m) => m.l2Chain24Svg) },
  l2ChainRTL24: { width: "24px", height: "24px", loader: () => import("./l2-chain-rtl_24.svg-7UVTOITU.js").then((m) => m.l2Chain24Svg) },
  settings24: { width: "24px", height: "24px", loader: () => import("./settings_24.svg-LB2NPHFL.js").then((m) => m.settings24Svg) },
  fusion24: { width: "24px", height: "24px", loader: () => import("./fusion_24.svg-DJY4GZBN.js").then((m) => m.fusion24Svg) },
  globe24: { width: "24px", height: "24px", loader: () => import("./globe_24.svg-3EBQMDCF.js").then((m) => m.globe24Svg) },
  image24: { width: "24px", height: "24px", loader: () => import("./image_24.svg-LMEQRSRL.js").then((m) => m.image24Svg) },
  sun24: { width: "24px", height: "24px", loader: () => import("./sun_24.svg-J2JEBXWO.js").then((m) => m.sun24Svg) },
  moon24: { width: "24px", height: "24px", loader: () => import("./moon_24.svg-UFSZTNKT.js").then((m) => m.moon24Svg) },
  command24: { width: "24px", height: "24px", loader: () => import("./command_24.svg-6ZPVIHIB.js").then((m) => m.command24Svg) },
  wallet24: { width: "24px", height: "24px", loader: () => import("./wallet_24.svg-NRI5NRWL.js").then((m) => m.wallet24Svg) },
  authRefresh36: { width: "36px", height: "36px", loader: () => import("./auth-refresh_36.svg-TLQZRG73.js").then((m) => m.authRefresh36Svg) },
  logoFull: { width: "102px", height: "40px", loader: () => import("./logo-full.svg-NZ5QLCII.js").then((m) => m.logoFullSvg) },
  unicornRun: { width: "38px", height: "24px", loader: () => import("./unicorn_run.svg-FIWXVX57.js").then((m) => m.unicornRunSvg) },
  fire48: { width: "48px", height: "48px", loader: () => import("./fire_48.png-H24EZB6E.js").then((m) => m.fire48Png) },
  emptySearch: { width: "160px", height: "160px", loader: () => import("./empty_search.svg-HTH3MFNW.js").then((m) => m.emptySearch) },
  // chain icons
  eth24: { width: "24px", height: "24px", loader: () => import("./eth_24.svg-QSL6GA7V.js").then((m) => m.eth24Svg) },
  bnb24: { width: "24px", height: "24px", loader: () => import("./bnb_24.svg-GK3J7TR7.js").then((m) => m.bnb24Svg) },
  op24: { width: "24px", height: "24px", loader: () => import("./op_24.svg-C7QI3DAY.js").then((m) => m.op24Svg) },
  matic24: { width: "24px", height: "24px", loader: () => import("./matic_24.svg-MR2PZC5O.js").then((m) => m.matic24Svg) },
  arbitrum24: { width: "24px", height: "24px", loader: () => import("./arbitrum_24.svg-EOHJT7SH.js").then((m) => m.arbitrum24Svg) },
  gnosis24: { width: "24px", height: "24px", loader: () => import("./gnosis_24.svg-OA645ZO3.js").then((m) => m.gnosis24Svg) },
  avalanche24: { width: "24px", height: "24px", loader: () => import("./avalanche_24.svg-RACIZF5H.js").then((m) => m.avalanche24Svg) },
  fantom24: { width: "24px", height: "24px", loader: () => import("./fantom_24.svg-HII4JJB6.js").then((m) => m.fantom24Svg) },
  aurora24: { width: "24px", height: "24px", loader: () => import("./aurora_24.svg-W4HBGYPD.js").then((m) => m.aurora24Svg) },
  klaytn24: { width: "24px", height: "24px", loader: () => import("./klaytn_24.svg-3HGJORYN.js").then((m) => m.klaytn24Svg) },
  zkSyncEra24: { width: "24px", height: "24px", loader: () => import("./zksyncera_24.svg-6GCDLJI2.js").then((m) => m.zkSyncEra24Svg) },
  base24: { width: "24px", height: "24px", loader: () => import("./base_24.svg-TRYUGEDS.js").then((m) => m.base24Svg) }
};

// libs/ui-components/src/lib/modules/icon/icon.element.ts
var IconElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.iconLoadTask = new Task(
      this,
      ([iconName]) => this.loadImage(iconName),
      () => [this.icon]
    );
  }
  render() {
    const styles = {
      width: this.width ?? this.iconRecord?.width,
      height: this.height ?? this.iconRecord?.height
    };
    return this.iconLoadTask.render({
      pending: () => html`<div style="${styleMap(styles)}"></div>`,
      complete: (svg) => {
        if (typeof svg === "function") {
          return svg({ ...styles, props: this.props });
        }
        return svg;
      }
    });
  }
  async loadImage(iconName) {
    if (!iconName) {
      throw new Error("icon is required field for inch-icon element");
    }
    this.iconRecord = icons[iconName];
    if (!this.iconRecord) {
      throw new Error(`icon name ${iconName} not exist`);
    }
    return await this.iconRecord.loader();
  }
};
IconElement.tagName = "inch-icon";
IconElement.styles = css`
    :host {
        display: flex;
        width: fit-content;
        height: fit-content;
    }
  `;
__decorateClass([
  property({ type: String, attribute: "icon" })
], IconElement.prototype, "icon", 2);
__decorateClass([
  property({ type: String, attribute: true })
], IconElement.prototype, "width", 2);
__decorateClass([
  property({ type: String, attribute: true })
], IconElement.prototype, "height", 2);
__decorateClass([
  property({ type: Object })
], IconElement.prototype, "props", 2);
IconElement = __decorateClass([
  customElement(IconElement.tagName)
], IconElement);
export {
  IconElement
};
//# sourceMappingURL=index.esm.js.map
